import { TranslateService } from '@ngx-translate/core';
import { Component, inject } from '@angular/core';
import { AuthenticationService } from "../../core/services/authentication/authentication.service";
import { MaintenanceplanService } from "../../rest/maintenanceplan.service";
import { Rest } from "../../rest/rest_client";
import { I18nService } from "../../services/i18n/i18n.service";
import { NotificationsService } from "../../services/notifications-service/notifications.service";
import { EntityFormComponent } from "../entity-form/entity-form.component";

@Component({
    selector: "app-maintenance-plan-form",
    templateUrl: "./maintenance-plan-form.component.html",
    styleUrls: ["./maintenance-plan-form.component.css"],
    providers: [MaintenanceplanService],
    standalone: false
})
export class MaintenancePlanFormComponent extends EntityFormComponent<Rest.MaintenancePlan> {
  protected i18nTranslate = inject(TranslateService);

    title: String;
    /**Permissions */
    disableSave: boolean;
    disableChangeStatus: boolean;

    constructor(
        private maintenanceplanService: MaintenanceplanService,
        notificationsService: NotificationsService,
        protected i18n: I18nService,
        protected authenticationService: AuthenticationService
    ) {
        super(
            maintenanceplanService,
            notificationsService,
            i18n,
            authenticationService
        );
    }

    ngOnInit() {
        super.ngOnInit();
    }

    beforeShow() {
        /**Permissions */
        if (this.isNew) {
            this.disableSave = false;
            this.title = this.i18nTranslate.instant('i18nMigrated.createMaintenancePlan');
            this.entity.owner = this.authenticationService.user;
        } else {
            this.title = this.i18nTranslate.instant('i18nMigrated.editMaintenancePlan');
            if (this.entity["_$update"] === true) {
                this.disableSave = false;
            } else {
                this.disableSave = true;
            }
            if (this.entity["_$changeStatus"] === true) {
                this.disableChangeStatus = false;
            } else {
                this.disableChangeStatus = true;
            }
        }
        /** */
    }
}
